export default __webpack_public_path__ + "static/media/power.487f1302.svg";